/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ip-reputation-db';
const componentName = 'ip-reputation-db-list-page-card';
const prefix = `${moduleName}.${componentName}`;

export const ipReputationDB = `${prefix}.ipReputationDB`;
export const nameFieldLabel = `${prefix}.nameFieldLabel`;
export const descriptionFieldLabel = `${prefix}.descriptionFieldLabel`;
export const vendorFieldLabel = `${prefix}.vendorFieldLabel`;
export const filenameLabel = `${prefix}.filenameLabel`;
export const fileTypeLabel = `${prefix}.fileTypeLabel`;
export const lastUpdate = `${prefix}.lastUpdate`;
export const baseIpv4 = `${prefix}.baseIpv4`;
export const baseIpv6 = `${prefix}.baseIpv6`;
export const incrementalIpv4 = `${prefix}.incrementalIpv4`;
export const incrementalIpv6 = `${prefix}.incrementalIpv6`;

export const ENGLISH = {
    [ipReputationDB]: 'IP Reputation DB',
    [nameFieldLabel]: 'Name',
    [descriptionFieldLabel]: 'Description',
    [vendorFieldLabel]: 'Vendor',
    [filenameLabel]: 'Filename',
    [fileTypeLabel]: 'Type',
    [lastUpdate]: 'Last Update {0}',
    [baseIpv4]: 'Base IPv4',
    [baseIpv6]: 'Base IPv6',
    [incrementalIpv4]: 'Incremental IPv4',
    [incrementalIpv6]: 'Incremental IPv6',
};
